import React from 'react';

var GameControllersHeadComponent = function (_a) {
    var children = _a.children;
    return React.createElement("div", { className: 'pgc-game-controllers-head' }, children);
};
var GameControllersHeadSpan = function (_a) {
    var text = _a.text, forCurrency = _a.forCurrency;
    return React.createElement("span", { className: "pgc-game-controllers-head-text ".concat(forCurrency ? 'usd' : '') }, text);
};
var GameControllersHead = Object.assign(GameControllersHeadComponent, {
    Span: GameControllersHeadSpan,
});

export { GameControllersHead };
